import { Dropdown } from "react-bootstrap";
import profilePlaceholder from "../../../assets/images/user-circle-white.png";

import "./UserMenu.scss";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import { msalConfig } from "../../../configs/MSAL.config";

const UserMenu = (props) => {
  const { instance } = useMsal();

  const logout = async () => {
    await instance.logout();
  };

  const login = async (e) => {
    e.preventDefault();
    try {
      await instance.loginRedirect({
        authority: process.env.REACT_APP_MSAL_AUTHORITY,
        scopes: msalConfig.auth.scopes,
      });
      closeMenu();
    } catch (error) {
      console.error(error);
    }
  };

  const closeMenu = () => {
    if (window.innerWidth < 800) {
      const navToggler = document.getElementsByClassName("navbar-toggler");
      navToggler[0].click();
    }
  };

  return (
    <>
      <UnauthenticatedTemplate>
        <a href="#" onClick={login}>
          Login
        </a>
      </UnauthenticatedTemplate>
      <AuthenticatedTemplate>
        <Dropdown className="profile-dropdown">
          <Dropdown.Toggle variant="success" id="dropdown-basic">
            <img
              src={profilePlaceholder}
              alt="mdo"
              width="32"
              height="32"
              className="rounded-circle"
            />
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {/*<Dropdown.Item href="/profile">Profile</Dropdown.Item>*/}
            <Dropdown.Item>
              <div onClick={logout}>Logout</div>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </AuthenticatedTemplate>
    </>
  );
};

export default UserMenu;
